<template>
  <div style="padding: 0" id="aggregateMobile">
    <div v-if="showPage" class="aggregatePage">
      <img ref="aggregateTitle" src="../../assets/aggregateTitle.png" style="width:100%" />
      <div ref="aggregateBody" class="aggregateBody" >
        <div v-for="(item, index) in aggregateList" :key="index" @click="jumpUrl(item.jumpurl)" class="aggregateItem">
          <div style="width:73%;display: flex;align-items: center">
            <div style="height:4.3vh;width:15%;margin-left:5.5%" >
              <img :src="item.iconpath" style="height:4.3vh;" />
            </div>
            <span class="itemTitle">{{item.menuname}}</span>
          </div>
          <div class="itemTag">
            点击查看
          </div>
        </div>
        
      </div> 
    </div>
     
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
let Time
import agreeBookDialog from "./agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'aggregateMobile',
  data () {
    return {
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      openId: '',
      showGuide: false,
      showPage: false,
      ABDialogShow:false,
      aggregateList:[
        // {id:0,title:"myPKFiT",img:require("../../assets/tumor.png"),link:""},
        // {id:1,title:"肺癌专区",img:require("../../assets/tumor.png"),link:""},
        // {id:2,title:"县域专区",img:require("../../assets/tumor.png"),link:""},
        // {id:3,title:"县域专区县域专区",img:require("../../assets/tumor.png"),link:""},
        // {id:2,title:"县域专区",img:require("../../assets/tumor.png"),link:""},
        // {id:3,title:"县域专区县域专区",img:require("../../assets/tumor.png"),link:""},
        // {id:4,title:"待添加",img:require("../../assets/tumor.png"),link:""}
      ]
    }
  },
  
  components: { agreeBookDialog },

   created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/aggregateMobile?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
 }
    //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
    if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }



    if (!localStorage.TaToken && !this.takedacode) {
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/aggregateMobile?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }
          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}



          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (!msg.data.isFollowed) {
                this.showGuide = true
                return
              }
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true

                } else {
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}


        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (!msg.data.isFollowed) {
              this.showGuide = true
              return
            }
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                 this.showPage = true
                 this.getDetail()
 
              } else {
                this.showGuide = true
              }
            }
          }
        })
      }
    }

    setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);
   },
  mounted () {
    document.title = '品牌专区'
    //计算内容区的min-height
    //this.$refs.aggregateBody.style.minHeight=document.body.clientHeight-this.$refs.aggregateTitle.height+"px";
    Time = setInterval(p => {
      if(this.showPage){
        this.$refs.aggregateBody.style.minHeight=document.body.clientHeight-this.$refs.aggregateTitle.height+"px";
      }
    }, 100)

    this.$router.push({query:{}})

  },
  computed: {
    
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },

    ABDialogShowFn() {
      this.ABDialogShow =false;
    },

    goback () {
      window.history.back()
    },

    jumpUrl(url){
      window.location.href=url.includes("?") ? url+"&jumptovctag=setted" : url+"?jumptovctag=setted";
    },
    //获取聚合页信息
    getDetail () {
      this.$axiox.get('/api/minisite/QueryAggregate').then(p => {
        console.log("aggregateList:",p)
        this.aggregateList=p
      })
    }
  },
  destroyed () {
    clearInterval(Time)
  },
}
</script>

<style scoped>
  .aggregatePage{
    width:100%;
    min-height:100vh;
    background: linear-gradient(to bottom, #e61c21 0%, #e61c21 50%, white 50%, white 100%);
    overflow:auto
  }

  .aggregateBody{
    width:100%;
    overflow:auto;
    background-color:white;
    border-top-left-radius: 24px;
  }

  .itemTitle{
    margin-left:7%;
    font-size:0.96rem;
    font-weight:bold;
  }

  .itemTag{
    width:20%;
    height:2.4vh;
    line-height:3vh;
    border-radius:7px;
    background-color:#fce5e4;
    color:#ee1100;
    font-size:0.76rem;
    display:flex;
    justify-content: center;
    align-items: center
  }

  .aggregateItem{
    width:86.67%;
    margin-left:6.67%;
    height:7.73vh;
    background-color:white;
    margin-top:4.4vh;
    border-radius: 7px;
    display:flex;
    align-items: center;
    box-shadow: 0px 0px 30px 1px rgba(52, 55, 63, 0.1);
  }
  .aggregateItem:first-child{
    width:86.67%;
    margin-left:6.67%;
    height:7.73vh;
    background-color:white;
    margin-top:5.6vh;
    border-radius: 7px;
    display:flex;
    align-items: center;
    box-shadow: 0px 0px 30px 1px rgba(52, 55, 63, 0.1);
  }

  .aggregateItem:last-child{
    width:86.67%;
    margin-left:6.67%;
    height:7.73vh;
    background-color:white;
    margin-top:4.4vh;
    margin-bottom: 5.6vh;
    border-radius: 7px;
    display:flex;
    align-items: center;
    box-shadow: 0px 0px 30px 1px rgba(52, 55, 63, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/login/aggregateMobile.vue